import { validateZipcode } from "core/model/utils/location";
import { validateCharacterLimit } from "core/model/utils/strings";
import { SEND_DOCUMENTS_CHARACTER_LIMIT } from "core/schemas/shared";
import { convertModelDefinition, valueDef } from "react-forms-state/src";

export const DRVgeneralFormDefinition = convertModelDefinition({
  // section zero
  ...valueDef("statutory_pension_insurance_number"),
  ...valueDef("pension_insurance_company_name"),
  ...valueDef("insurance_company_name_address"),
  ...valueDef("hospital_name_address"),
  ...valueDef("social_worker_name_number"),
  ...valueDef("preferred_rehab_clinic"),

  // section one
  ...valueDef("requested_rehab_service"),
  ...valueDef("requested_rehab_service_type_insured"),
  ...valueDef("requested_rehab_service_type_relatives"),

  // section two
  ...valueDef("patient_first_name"),
  ...valueDef("patient_last_name"),
  ...valueDef("patient_birth_name"),
  ...valueDef("patient_maiden_name"),
  ...valueDef("gender_extended"),
  ...valueDef("patient_birthdate"),
  ...valueDef("patient_street_housenumber"),
  ...valueDef("patient_zipcode", { validate: validateZipcode(false) }),
  ...valueDef("patient_city"),
  ...valueDef("patient_phone_number"),
  ...valueDef("patient_nationality"),

  // section three
  ...valueDef("care_person_necessary"),

  // section four
  ...valueDef("marital_status"),
  ...valueDef("last_employment"),

  // section five
  ...valueDef("employment_status"),

  // section six
  ...valueDef("prior_employment_status"),

  // section seven
  ...valueDef("insurance_type"),
  ...valueDef("insurance_name"),
  ...valueDef("patient_unable_to_work_before_hospitalization"),
  ...valueDef("patient_unable_to_work_before_hospitalization_date"),

  // section eight
  ...valueDef("doctor_in_charge_in_hospital"),
  ...valueDef("doctor_in_charge_in_hospital_first_name"),
  ...valueDef("street_house_number_doctor"),
  ...valueDef("postal_code_doctor", { validate: validateZipcode(false) }),
  ...valueDef("town_doctor"),
  ...valueDef("doctor_in_charge_in_hospital_phone"),

  // section nine
  ...valueDef("contributions_to_statutory_pension"),
  ...valueDef("contributions_to_foreign_insurance_info"),
  ...valueDef("contributions_to_foreign_insurance_info_from_to"),
  ...valueDef("contributions_to_foreign_insurance_info_state"),
  ...valueDef("contributions_to_foreign_insurance_current"),

  // section ten
  ...valueDef("unemployment_benefit_type_2"),
  ...valueDef("jobcenter_name"),

  // section eleven
  ...valueDef("special_payments_from_civil_services"),
  ...valueDef("retirement_pension_received_applicable"),
  ...valueDef("retirement_pension_received"),
  ...valueDef("before_retirement_pension_applicable"),
  ...valueDef("before_retirement_pension"),
  ...valueDef("health_damage_present"),
  ...valueDef("health_damage_origin"),
  ...valueDef("health_damage_file_number"),
  ...valueDef("health_damages_description"),
  ...valueDef("application_submitted_applicable"),
  ...valueDef("application_submitted"),
  ...valueDef("risk_of_incapacity_caused_by_accident_third_person"),
  ...valueDef("claim_for_damages_approved"),
  ...valueDef("claim_for_damages_origin"),
  ...valueDef("claim_for_damages_file_number"),
  ...valueDef("claim_for_damages_description"),

  // section twelve
  ...valueDef("third_party_request"),
  ...valueDef("contact_guardian"),
  ...valueDef("legal_guardian_type"),
  ...valueDef("legal_guardian_house_number"),
  ...valueDef("legal_guardian_zip_code", { validate: validateZipcode(false) }),
  ...valueDef("legal_guardian_town"),
  ...valueDef("legal_guardian_phone"),
  ...valueDef("legal_guardian_email"),
  ...valueDef("consent_of_the_insured"),

  // section thirteen
  ...valueDef("needs_disability_equipment_applicable"),
  ...valueDef("needs_disability_equipment"),

  // section fourteen
  ...valueDef("send_documents_per_email"),
  ...valueDef("send_documents_per_email_description", {
    validate: (value, props) =>
      validateCharacterLimit(SEND_DOCUMENTS_CHARACTER_LIMIT)(value, props),
  }),
  ...valueDef("visually_impaired_document"),
});
